import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { BRAND } from "../data/content";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/meal-prep", label: "Meal Prep" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-charcoal-void text-platinum">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <img
              src={BRAND.logo}
              alt="Taste of Platinum"
              data-testid="footer-logo"
              className="w-16 h-16 rounded-full object-cover ring-1 ring-gold/40 mb-4"
            />
            <div className="font-serif text-2xl font-semibold text-white">
              Taste of <span className="gold-text">Platinum</span>
            </div>
            <p className="mt-3 text-sm text-platinum-dark italic">
              Elevated Island Flavor. Platinum Experience.
            </p>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-2 text-sm text-gold hover:bg-gold hover:text-charcoal transition-colors"
            >
              <Instagram className="w-4 h-4" /> @{BRAND.instagram}
            </a>
          </div>

          <div>
            <div className="eyebrow text-gold mb-4">Explore</div>
            <ul className="grid grid-cols-2 gap-y-2 text-sm">
              {LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-platinum hover:text-gold transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow text-gold mb-4">Get In Touch</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-gold shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-gold break-all">{BRAND.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-gold shrink-0" />
                <span>{BRAND.serviceArea}</span>
              </li>
            </ul>
            <Link
              to="/meal-prep"
              className="mt-5 inline-flex rounded-full bg-gold px-5 py-2.5 text-sm font-semibold text-charcoal hover:bg-gold-bright"
            >
              Explore Meal Prep
            </Link>
          </div>
        </div>

        <div className="gold-line mt-12" />
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-platinum-dark">
          <p>© {new Date().getFullYear()} Taste of Platinum. All rights reserved.</p>
          <p>Serving {BRAND.serviceArea}</p>
        </div>
      </div>
    </footer>
  );
}
